import React from 'react';
import { ResourceProps } from 'react-admin';

// Mesa. La ficha de cada movimiento se despliega dentro de la propia fila, así
// que el resource ya no expone `show` ni `edit` como rutas sueltas: la edición
// del registro vive en la ficha del inversor, donde está el contexto.
let resourceProps: ResourceProps = {
  name: 'transactions',
  list: React.lazy(() => import(/* webpackChunkName: "c-mesa" */ '../../console/pages/mesa')),
};

export default resourceProps;
